import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/actions";

import {
  AEAutoComplete,
  AEFile,
  AEInput,
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  AECheckbox,
} from "../../../../../../_metronic/_partials/controls";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { CONTEXT } from "../../../helpers/ModuleHelpers";
import { useIntl } from "react-intl";
import { actionTypes } from "../../../_redux/slice";
import {
  HTTP_CREATED,
  HTTP_UPDATED,
} from "../../../../../../_emywork/helpers/AxiosHelpers";
import { ModuleProvider, useModuleContext } from "../../../ModuleContext";
import { AEButton } from "../../../../../../_emywork/components/buttons";
import { useFormik, Field } from "formik";
import * as Yup from "yup";
import {
  YupAuthEmail,
  YupPhone,
} from "../../../../../../_emywork/yupjs/Schema";
import { localField } from "../../../../../../_emywork/helpers/UIHelper";
import { actionTypes as legalFormsActionTypes } from "../../../../LegalForms/_redux/slice";
import { actionTypes as locationsActionTypes } from "../../../../Locations/_redux/slice";
import { actionTypes as functionsActionTypes } from "../../../../Functions/_redux/slice";
import { actionTypes as skillsActionTypes } from "../../../../Skills/_redux/slice";
import { actionTypes as activityAreasActionTypes } from "../../../../ActivityAreas/_redux/slice";
import {
  AEMetadata,
  defaultMeta,
} from "../../../../../../_emywork/AEPagination";
import {
  fetchEntities as getSkills,
  resetEntities as resetSkills,
} from "../../../../Skills/_redux/actions";
import {
  fetchEntities as getLocations,
  resetEntities as resetLocations,
} from "../../../../Locations/_redux/actions";
import { fetchEntities as getLegalForms } from "../../../../LegalForms/_redux/actions";
import { fetchEntities as getActivityAreas } from "../../../../ActivityAreas/_redux/actions";
import { fetchEntities as getFunctions } from "../../../../Functions/_redux/actions";

import { authActions } from "../../../../Auth/_redux/authRedux";
import { AERole } from "../../../../../../_emywork/components/AERole";
import { roles } from "../../../../../App";
import {
  AEUserBadge,
  BADGES,
} from "../../../../../../_emywork/components/AEBadge";
import UserActivationBadge, {
  IS_ACTIVE_STATUSES,
} from "../../../../../../_emywork/components/badges/UserActivationBadge";

const validationSchema = Yup.object().shape({
  // username: YupAuthUsername(),
  phone: YupPhone(),
  email: YupAuthEmail(),
  commercial_name: Yup.string(),
  legal_form_id: Yup.number().required(),
  location_id: Yup.number().required(),
  activity_area_id: Yup.number().nullable(true),
  function_id: Yup.number().nullable(true),
  skills: Yup.array(),
  is_private: Yup.bool().default(false),
  // is_active: Yup.object(),
});

export function PersonalForm(props) {
  return (
    <ModuleProvider>
      <PersonalFormContent {...props} />
    </ModuleProvider>
  );
}

function PersonalFormContent({
  history,
  match: {
    params: { username },
  },
}) {
  const { formatMessage } = useIntl();
  const { openDetailsPage } = useModuleContext();
  const dispatch = useDispatch();

  const {
    isLoading,
    entity,
    validationErrors,
    authUser,
    /*countries, */ legal_forms,
    locations,
    functions,
    activity_areas,
    skills,
    locations_loading,
    legal_forms_loading,
    functions_loading,
    skills_loading,
    activity_areas_loading,
    is_active,
  } = useSelector((state) => {
    //TODO names
    const { isLoading, entity, validationErrors } = state[CONTEXT][
      actionTypes.Edit
    ];

    // const {entities: countries} = state.countries[countriesActionTypes.UserEditList]
    const {
      entities: legal_forms,
      isLoading: legal_forms_loading,
    } = state.legal_forms[legalFormsActionTypes.UserEditList];
    const {
      entities: locations,
      isLoading: locations_loading,
    } = state.locations[locationsActionTypes.UserEditList];
    const {
      entities: functions,
      isLoading: functions_loading,
    } = state.functions[functionsActionTypes.UserEditList];
    const { entities: skills, isLoading: skills_loading } = state.skills[
      skillsActionTypes.UserEditList
    ];
    const {
      entities: activity_areas,
      isLoading: activity_areas_loading,
    } = state.activity_areas[activityAreasActionTypes.UserEditList];

    return {
      isLoading,
      entity,
      validationErrors,
      authUser: state.auth.user,
      /*countries, */
      locations,
      locations_loading,
      legal_forms,
      legal_forms_loading,
      functions,
      functions_loading,
      skills,
      skills_loading,
      activity_areas,
      activity_areas_loading,
    };
  }, shallowEqual);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...entity,
      is_active: IS_ACTIVE_STATUSES.find((s) => s.id === Number(is_active)),
    },
    initialErrors: validationErrors,
    validationSchema,
    onSubmit: ({ file_name, ...values }) => {
      values.skills = values.skills.map((s) => s.id);
      values.is_active = values.is_active.id;

      if (!values.id) {
        dispatch(
          actions.createEntity({ entity: values, files: file_name })
        ).then((r) => {
          if (r.status === HTTP_CREATED) {
            openDetailsPage(r.entity.username);
          }
        });
      } else {
        // console.log('update entity')
        dispatch(
          actions.updateEntity({ entity: values, files: file_name })
        ).then((r) => {
          if (r.status === HTTP_UPDATED) {
            dispatch(authActions.requestUser());
            openDetailsPage(values.username);
          }
        });
      }
    },
  });

  const {
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    setValues,
  } = formik;

  // Hooks

  useEffect(() => {
    setValues(entity);
  }, [entity]);

  useEffect(() => {
    dispatch(
      actions.fetchEntity(
        username || authUser.username,
        new AEMetadata({}, {}, {}, ["*", "skills"])
      )
    );
  }, [username, dispatch]);

  useEffect(() => {
    // dispatch(getCountries(defaultMeta, countriesActionTypes.UserEditList))
    dispatch(getLegalForms(defaultMeta, legalFormsActionTypes.UserEditList));
    dispatch(
      getActivityAreas(defaultMeta, activityAreasActionTypes.UserEditList)
    );
    dispatch(getFunctions(defaultMeta, functionsActionTypes.UserEditList));
    dispatch(getSkills(defaultMeta, skillsActionTypes.UserEditList));
    // dispatch(getLocations(defaultMeta, skillsActionTypes.UserEditList))
    dispatch(
      getLocations(
        new AEMetadata({ perPage: 1000 }, {}, {}, [
          "id",
          localField(),
          "country",
        ]),
        locationsActionTypes.UserEditList
      )
    );
  }, []);

  // useEffect(()=>{
  //   if(values.country_id){
  //     dispatch(getLocations(new AEMetadata({},{},{country_id:values.country_id},['id',localField()]), locationsActionTypes.UserEditList))
  //   }else {
  //     setFieldValue("location_id", undefined)
  //     dispatch(resetLocations(locationsActionTypes.UserEditList))
  //   }
  // }, [values.country_id])

  const _props = (name, label, type) => {
    let p = {
      name,
      label,
      field: getFieldProps(name),
      form: formik,
    };

    switch (type) {
      case "autocomplete":
        {
          p.useId = true;
          p.getOptionLabel = (o) => o[localField()];
        }
        break;
    }

    return p;
  };

  //WORKS WELL
  // return (
  //   <Formik
  //     enableReinitialize={true}
  //     initialValues={entity}
  //     validationSchema={validationSchema}
  //     onSubmit={values=>{
  //
  //     }}
  //   >
  //     <Field
  //       label={'LOCATION'}
  //       component={AEAutoComplete}
  //       name={'location_id'}
  //       useId
  //       getOptionLabel={o=>o.name_en}
  //       options={locations}
  //       />
  //   </Formik>
  // )

  const InputStyle = {
    position: 'absolute',
    right: '28px',
    margin: '9px 0 0 0'
  }

  const lock = <span style={InputStyle} ><i style={{ color: 'var(--dark)' }} className="fa fa-solid fa-lock"></i></span>

  return (
    <Card>
      {isLoading && <ModalProgressBar />}
      <CardHeader title={formatMessage({ id: "PERSONAL_INFORMATION" })}>
        <CardHeaderToolbar>
          <AEButton variant={"primary"} className="ml-2" onClick={handleSubmit}>
            {formatMessage({ id: "SAVE_CHANGES" })}
          </AEButton>
          <AEButton
            variant={"light"}
            className="ml-2"
            onClick={() => {
              history.goBack();
              // openDetailsPage(username)
            }}
          >
            {formatMessage({ id: "CANCEL" })}
          </AEButton>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "AVATAR" })}
          </label>
          <div className="-col-lg-9 -col-xl-6 -w-150px -h-150px">
            <AEFile
              {..._props("file_name", "AVATAR")}
              accept={"image/*"}
              preview
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "PHONE" })}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEInput {..._props("phone", "PHONE")} />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "EMAIL" })}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEInput {..._props("email", "EMAIL")} disabled />{lock}
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "COMMERCIAL_NAME" })}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEInput {..._props("commercial_name", "COMMERCIAL_NAME")} disabled />{lock}
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "ABOUT" })}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEInput
              {..._props("about", "ABOUT")}
              type={"textarea"}
              rows={10}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "LEGAL_FORM" })}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEAutoComplete
              {..._props("legal_form_id", "LEGAL_FORM", "autocomplete")}
              options={legal_forms}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "LOCATION" })}
          </label>
          {/*<div className="col-lg-4 col-xl-3">*/}
          {/*  <AEAutoComplete*/}
          {/*    {..._props('country_id','COUNTRY', 'autocomplete')}*/}
          {/*    options={countries}*/}
          {/*  />*/}
          {/*</div>*/}
          <div className="col-lg-9 col-xl-6">
            <AEAutoComplete
              {..._props("location_id", "LOCATION", "autocomplete")}
              options={locations}
              getOptionLabel={(o) =>
                [o[localField()] /*, o.country[localField()]*/].join(" - ")
              }
              loading={locations_loading}
            />
          </div>
        </div>

        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "ACTIVITY_AREA" })}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEAutoComplete
              {..._props("activity_area_id", "ACTIVITY_AREA", "autocomplete")}
              options={activity_areas}
              loading={activity_areas_loading}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "FUNCTION" })}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEAutoComplete
              {..._props("function_id", "FUNCTION", "autocomplete")}
              options={functions}
              loading={functions_loading}
            />
          </div>
        </div>

        {username && (
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label">
              {formatMessage({ id: "BADGE" })}
            </label>
            <div className="col-lg-9 col-xl-6">
              <AEAutoComplete
                {..._props("badge", "BADGE", "autocomplete")}
                options={Object.keys(BADGES)}
                getOptionLabel={(o) => formatMessage({ id: o })}
                renderOption={(o) => {
                  return (
                    <div>
                      <AEUserBadge id={o} />
                      {formatMessage({ id: o })}
                    </div>
                  );
                }}
                useId={false}
              />
            </div>
          </div>
        )}
        {username && (
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label">
              {formatMessage({ id: "STATUS" })}
            </label>
            <div className="col-lg-9 col-xl-6">
              <AEAutoComplete
                // id="combo-box-demo"
                {..._props("is_active", "STATUS")}
                // field={getFieldProps("is_active")}
                autoComplete
                form={formik}
                label={"STATUS"}
                options={IS_ACTIVE_STATUSES}
                getOptionLabel={(o) => {
                  //transforms back the value to an object
                  if (typeof Number(o) === "number" && typeof o !== "object") {
                    o = IS_ACTIVE_STATUSES.find((s) => s.id === Number(o));
                  }

                  return formatMessage({ id: o?.label });
                }}
                renderOption={(option, state) => {
                  //TODO refactor
                  if (
                    typeof Number(option) === "number" &&
                    typeof option !== "object"
                  ) {

                    option = IS_ACTIVE_STATUSES.find(
                      (s) => s.id === Number(option)
                    );
                  }
                  return (
                    <div>
                      <UserActivationBadge
                        activationStatus={option?.label || undefined}
                      />
                      {formatMessage({ id: option.label })}
                    </div>
                  );
                }}
              />
            </div>
          </div>
        )}

        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "SKILLS" })}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEAutoComplete
              {..._props("skills", "SKILLS", "autocomplete")}
              options={skills}
              multiple
              useId={false}
              loading={functions_loading}
            />
          </div>
        </div>

        <div className="form-group row py-1">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({ id: "ACCOUNT.VISIBILITY" })}
          </label>
          <div className={`col-lg-4`}>
            <AECheckbox {..._props("is_private",
              Number(entity.is_private) === 1
                ?
                `${formatMessage({ id: "ACCOUNT.VISIBILITY.STATUS.PRIVATE" })}  |  ${formatMessage({ id: "ACCOUNT.VISIBILITY.TO_PUBLIC" })}`
                :
                `${formatMessage({ id: "ACCOUNT.VISIBILITY.STATUS.PUBLIC" })}  |  ${formatMessage({ id: "ACCOUNT.VISIBILITY.TO_PRIVATE" })}`
            )} />
          </div>
        </div>


        <AERole accept={[roles.super_admin]}>
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label">
              {formatMessage({ id: "ROLES" })}
            </label>
            <div className="col-lg-9 col-xl-6">
              <AEAutoComplete
                {..._props("roles", "ROLES", "autocomplete")}
                options={[roles.super_admin, roles.provider, roles.client]}
                multiple
                useId={false}
                getOptionLabel={(id) => formatMessage({ id })}
              />
            </div>
          </div>
        </AERole>
      </CardBody>
    </Card>
  );
}
